import { ContextSearchResult } from 'store/types/searchResults'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../ui/card'
import { Badge } from '../ui/badge'
import { useNavigate } from 'react-router-dom'

interface ProductCardProps {
  product: ContextSearchResult
}

export const ProductCard = ({ product }: ProductCardProps) => {
  const navigate = useNavigate()

  return (
    <Card
      className="group cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
      onClick={() =>
        navigate(
          `/toolbox/standard-parts/details/${product.sid}?countryCode=OECD1&variant=var1`
        )
      }
    >
      <CardHeader className="space-y-4">
        <div className="aspect-square relative bg-muted rounded-md overflow-hidden flex items-center justify-center p-4">
          <img
            src={product.imgUrl}
            alt={product.name}
            className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
          />
        </div>
        <div className="space-y-2">
          <CardTitle className="text-lg line-clamp-2 leading-snug">
            {product.name}
          </CardTitle>
          <CardDescription className="line-clamp-2">
            {product.description}
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex flex-wrap gap-2">
          <Badge variant="secondary" className="text-xs">
            {product?.fullContext?.className ?? '—'}
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground">
          <span className="font-medium">SID:</span> {product.sid}
        </p>
      </CardContent>
    </Card>
  )
}
